const baseURL = "https://vi8l3gdq48.execute-api.ap-south-1.amazonaws.com/dev/api/creditNote/"

export const createCreditNote = baseURL+"createCreditNote"
export const getAllCreditNote = baseURL+"viewAllCreditNotesList/"
